import DbEntity from "./DbEntity";

export default class Destinazioni extends DbEntity {
    constructor() {
        super("destinazioni", [['idanagrafica']]);
    }

    async getByIdAnagrafica(idanagrafica) {
        try {
            const resp = await this.db.find({
                selector: {
                    idanagrafica: {$eq: parseInt(idanagrafica)}
                },
                sort: ['idanagrafica'],
            });
            return resp;
        } catch (e) {
            console.log(e);
        }
    }

}